import { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../../firebase";

const PoomUsersTable = () => {
    const [poomUserData, setPoomUserData] = useState([]);
    useEffect(() => {
      const collectionRef = query(collection(db, "users"), orderBy('joinedOn', 'desc'));
      const getPoomUserData = async () => {
        try {
          const data = await getDocs(collectionRef);
          setPoomUserData(
            data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
          );
        } catch (error) {
          console.log(error);
        }
      };
      getPoomUserData();
    }, []);

  return (
    <div className="max-w-[1200px] mx-auto my-16 p-4">
      <h2 className="text-2xl font-bold py-2 text-center">Poom Users:</h2>
      <div className="grid gap-2 lg:grid-cols-2 place-items-center">
        {poomUserData.map((data) => {
          return (
            <>
              <div className="w-full p-2 rounded-lg shadow-xl lg:flex lg:max-w-lg">
                <img
                  className="object-cover w-full lg:w-40 lg:h-40"
                  src={data.profileImage}
                  alt="profile pic"
                />
                <div className="pl-2">
                  <h4 className="text-xl font-semibold tracking-tight">
                    {data.fullName}
                  </h4>
                  <p className="mt-2 leading-normal">
                    Joined On:{" "}
                    {data.joinedOn && data.joinedOn.toDate().toDateString()}
                  </p>
                  <p className="leading-normal">Email: {data.email}</p>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default PoomUsersTable;
